export * as containers from './containers';




// WEBPACK FOOTER //
// ./src/modules/core/index.js